const TAGS_UUID_LENGTH = 36

export const regexTimestamp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/
export const tagIdRegex = new RegExp(`#([\\w-_]{${TAGS_UUID_LENGTH}})`, 'g')
